<template>
<div class="fc-page mg-page"><header class="fc-heading"><div class="fc-child-heading"><h1>系统配置</h1><p>设置机构教学管理的基础规则</p></div></header><section class="fc-records mg-config"><div class="fc-list-heading"><h3>老师奖金计算方式</h3><span class="mg-help">选择适合校区的计算口径</span></div><div class="mg-section-body"><v-radio-group v-model="config.teacherBonusType" >
								<v-radio value="1" label="1.按核销课时数计算，核销1课时奖励X元" color="red"></v-radio>
								<v-radio value="2" label="2.按到课学生数计算，到课1人奖励X元" color="red"></v-radio>
								<v-radio value="3" label="3.按上课次数计算,每次上课奖励X元" color="red"></v-radio>
								<v-radio value="4" label="4.不需要系统计算" color="red"></v-radio>
							</v-radio-group><div v-if="config.teacherBonusType !=='4'" class="mg-config-amount">
							<v-text-field v-model="config.teacherBonusFee" type="number" label="奖励金额" dense outlined style="width:100px" color="#d9363e" aria-label="奖励金额"></v-text-field>
							<span class="ml-2 mt-3">元</span>
							<v-spacer></v-spacer>

						</div></div><div class="mg-config-footer"><v-btn color="#d9363e" class="mg-create" @click="submitConfig" depressed>提交修改</v-btn></div></section></div>
</template>

<script>
	export default {
		name:"config",
		data(){
			return {
				config:{
					id:"",
					teacherBonusType:"",// 提成方式
					teacherBonusFee:"",//奖金金额
				},
			}
		},
		created(){
			this.getConfig();
		},
		methods:{
			submitConfig(){
				//提交修改配置
				if(!this.config.teacherBonusType){
					this.$noty.error("请选择教师奖金计算方式");
					return
				}
				if(this.config.teacherBonusType !=='4'){
					if(!this.config.teacherBonusFee){
						this.$noty.error("请输入奖励金额");
						return
					}
				}
				// api
				const that = this;
				let url = `/sys/config/update`;
				let postData = this.config;
		
				this.axios.post(url, postData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("提交成功");
							that.getConfig();
				
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}
				});
			},
			getConfig(){
				// 获取配置
				const that = this;
	
				let url = `/sys/config`;
				this.axios.get(url).then(response => {
					
					console.log(response);
					
					if (response.data["code"] === 200) {
						const resData = response.data["data"];
						that.config.id = resData["id"];
						that.config.teacherBonusType = resData["teacherBonusType"];
						that.config.teacherBonusFee = resData["teacherBonusFee"];
						
						return
					}
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			}
		}
		
	};
</script>
<style>
</style>
<style lang="scss" scoped src="../../../assets/styles/management.scss"></style>
